// extracted by mini-css-extract-plugin
module.exports = {"CollapseToggleBar":"Collapse__CollapseToggleBar___-rQZ-","action":"Collapse__action___5w8Yp","CollapseBody":"Collapse__CollapseBody___CNhm6","Hide":"Collapse__Hide___3CZ91"};